import React, { useState, useCallback } from 'react';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { base64ToBlob, blobToFile, readCookie, createCookie } from '../../../utils/common';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { clone, get } from 'lodash';
import { getQueryString } from '../../../utils/common';
import { logout, saveHeadImg } from './action';
import { Toast, Modal } from 'antd-mobile';
import { _track } from '../../../utils/track';
import { Checked } from '../../../components/icons/checked';
import { Camera } from '../../../components/icons/camera';
import { Contract } from '../../../components/icons/contract';
import { Vh5Cropper } from '../../../components/cropper';
import { actionCopyrightUpload } from '../../commonAction';
import './index.scss';
const mapStateToProps = state => {
	return {
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo
	};
};
const CopyrightSetting = props => {
	let [dialogVisible, setDialogVisible] = useState(false);
	let [imgFile, setImgFile] = useState(null);
	let [imgType, setImgType] = useState('image/jpeg');
	const mapState = useCallback(mapStateToProps, []);
	const { baseInfo = {} } = useMappedState(mapState);
	let { avatar } = baseInfo;
	console.log('avatar.......', avatar);
	let history = useHistory();
	let dispatch = useDispatch();
	let title = decodeURIComponent(getQueryString('title') || '');
	let token = readCookie('userToken');
	let nickname = readCookie('copyright_nickname') || '';
	let phone = readCookie('copyrightphone') || '';
	let instName = readCookie('copyright_instName') || '';
	let copyright_iscontract = readCookie('copyright_iscontract') === 'true';
	let userId = readCookie('copyrightuserId');
	if (!userId || userId === 'null') {
		// 未登录直接进入ucenter
		window.location.href = '/vpmobile/copyright/login';
	}
	function toTodayImg() {
		_track({
			trackName: 'toutu_setting_page',
			payload: {
				PCenter_setting_Action: '关于投图'
			}
		});
		history.push({
			pathname: '/vpmobile/copyright/about'
		});
	}
	function toCopyrightNotice() {
		_track({
			trackName: 'toutu_setting_page',
			payload: {
				PCenter_setting_Action: '版权声明'
			}
		});
		history.push({
			pathname: '/vpmobile/copyright/notice'
		});
	}
	function handleLogout() {
		dispatch(
			logout(
				{ token },
				data => {
					console.log('data', data);
					//{"token":"082a5e0dd6177fb29ff8d2e05ed50ffd","userId":19315}
					createCookie('userToken', '', -1);
					createCookie('copyrightuserId', '', -1);
					createCookie('copyrightphone', '', -1);
					_track({
						trackName: 'toutu_setting_page',
						payload: {
							...data,
							page_action_name: 'settting-logout',
							PCenter_setting_Action: '退出登录'
						}
					});
					Toast.success('退出成功', 1, () => {
						window.location.href = '/vpmobile/copyright/login';
					});
				},
				data => {
					console.log('error data', data);
					createCookie('userToken', '', -1);
					createCookie('copyrightuserId', '', -1);
					createCookie('copyrightphone', '', -1);
					Toast.fail('退出失败');
					_track({
						trackName: 'toutu_setting_page',
						payload: {
							...data,
							page_action_name: 'settting-logout'
						}
					});
				}
			)
		);
	}
	function Organization(props) {
		return (
			<div className="organization">
				<Checked />
				<span>{props.name}</span>
			</div>
		);
	}
	function InstitutionItem() {
		if (instName && instName !== 'null') {
			return (
				<li className="set-item institution">
					<span className="title">机构认证</span>
					{/* <span className="content">{instName}</span> */}
					<Organization name={instName} />
				</li>
			);
		}
		return '';
	}
	function Photographer(props) {
		return (
			<div className="photographer">
				<Camera />
				<span>摄影师</span>
			</div>
		);
	}
	function ContractPhotographer(props) {
		return (
			<div className="photographer">
				<Contract />
				<span>认证摄影师</span>
			</div>
		);
	}
	function JobItem() {
		let item = copyright_iscontract ? <ContractPhotographer /> : <Photographer />;
		return (
			<li className="set-item job">
				<span className="title">职业认证</span>
				{item}
			</li>
		);
	}
	function NicknameItem() {
		return (
			<li className="set-item nickname">
				<span className="title">我的署名</span>
				<span className="content">
					<span>{nickname}</span>
					<span
						className="arrow"
						onClick={() => {
							_track({
								trackName: 'toutu_setting_page',
								payload: {
									page_action_name: 'settting-pushpathname-editor',
									PCenter_setting_Action: '作者署名'
								}
							});
							window.scrollTo(0, 0);
							history.push({ pathname: '/vpmobile/copyright/editor' });
						}}></span>
				</span>
			</li>
		);
	}
	function PhoneItem() {
		if (phone) {
			return (
				<li className="set-item phone">
					<span className="title">我的手机号</span>
					<span className="content">{phone}</span>
				</li>
			);
		}
		return '';
	}
	function cropperCallback(data) {
		if (data) {
			let formData = new FormData();
			let blob = base64ToBlob(data);
			let fileData = blobToFile(blob, 'image');
			formData.append('files', fileData);
			dispatch(
				actionCopyrightUpload(
					formData,
					data => {
						let avatarOssKey = get(data.data, ['0'], '');
						console.log('data', data);
						dispatch(
							saveHeadImg(
								{
									avatarOssKey: avatarOssKey.key,
									userId
								},
								({ avataUrl }) => {
									console.log('save....', avataUrl);
								}
							)
						);
						setDialogVisible(false);
					},
					data => {
						console.log(data);
					}
				)
			);
		}
	}
	function onChangeUpload(event) {
		let { files, value } = event.target;
		let suffixArray = ['.jpg', '.jpeg', '.png'];
		let _imgType = value.substring(value.lastIndexOf('.')).toLowerCase();
		if (!suffixArray.includes(_imgType)) {
			Toast.info('请上传JPG，PNG格式的图片');
			return;
		}
		if (files && files.length > 0) {
			let img = files[0];
			// if (parseInt(img.size / 1024, 10) > 1024 * 5) {
			// 	Toast.info('图片大小超过5M,请重新上传');
			// 	return;
			// }
			let url = URL.createObjectURL(img);
			event.target.value = '';
			setImgFile(url);
			setImgType(img.type || 'image/jpeg');
			_track({
				trackName: 'toutu_setting_page',
				payload: {
					PCenter_setting_Action: '我的头像'
				}
			});
		}
		setDialogVisible(true);
	}
	console.log('avatar end', avatar);
	return (
		<div className="copyright copyright-setting">
			{/* <!-- 头部导航栏 开始 --> */}
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							window.location.href = '/vpmobile/copyright/ucenter/';
						}}>
						返回
					</label>
				</div>
				<span className="title">设置</span>
			</header>
			{/* <!-- 头部导航栏 结束 -->
            <!-- 正文内容 开始 --> */}
			<section className="main-content">
				<div className="set-container">
					<ul className="set-list">
						<li className="set-item avatar-item">
							<span className="title">我的头像</span>
							<span className="content">
								{avatar ? <img src={avatar} alt="" className="avatar" /> : <span className="iconfont avatar">&#xe64f;</span>}
								<input className="upload" type="file" onChange={onChangeUpload} />
							</span>
							<span className="arrow"></span>
						</li>
						<NicknameItem />
						<PhoneItem />
						<InstitutionItem />
						<JobItem />
						<li className="set-item about" onClick={toTodayImg}>
							<span className="title">关于投图</span>
							<span className="arrow"></span>
						</li>
						<li className="set-item copyright" onClick={toCopyrightNotice}>
							<span className="title">版权声明</span>
							<span className="arrow"></span>
						</li>
						<li className="set-item tel">
							<span className="title">客服电话</span>
							<span className="content">400-806-5775</span>
						</li>
					</ul>
				</div>
				<div className="log-out-btn" onClick={handleLogout}>
					退出登录
				</div>
				<Modal
					className="modal-cropper"
					visible={dialogVisible}
					transparent={true}
					closable={false}
					onClose={() => {
						setDialogVisible(false);
					}}>
					<Vh5Cropper
						previewClassName="j_preview"
						imgData={imgFile}
						imgType={imgType}
						cropperCallback={cropperCallback}
						onClose={() => {
							setDialogVisible(false);
						}}
					/>
				</Modal>
			</section>
			{/* <!-- 正文内容 结束 --> */}
		</div>
	);
};
export { CopyrightSetting };
